import triggersController from './triggersController'

export default triggersController



// WEBPACK FOOTER //
// ../src/controllers/triggersController/index.js